/* eslint-disable max-len */
import React from 'react';

export const InsertPluginIcon = props => (
  <svg width="19" height="19" viewBox="0 0 19 19" {...props}>
    <g>
      <path d="M4 3.2v12.6c0 .11-.09.2-.2.2h-.6c-.11 0-.2-.09-.2-.2V3.2c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2z" />
      <rect width="7" height="1" x="2" y="10" rx=".2" transform="rotate(90 5.5 10.5)" />
      <rect width="9" height="1" x="3" y="9" rx=".2" transform="rotate(90 7.5 9.5)" />
      <rect width="7" height="1" x="6" y="10" rx=".2" transform="rotate(90 9.5 10.5)" />
      <rect width="5" height="1" x="9" y="11" rx=".2" transform="rotate(90 11.5 11.5)" />
      <rect width="5" height="1" x="13" y="11" rx=".2" transform="rotate(90 15.5 11.5)" />
      <rect width="7" height="1" x="10" y="10" rx=".2" transform="rotate(90 13.5 10.5)" />
      <path d="M4.2 15h12.6c.11 0 .2.09.2.2v.6c0 .11-.09.2-.2.2H4.2c-.11 0-.2-.09-.2-.2v-.6c0-.11.09-.2.2-.2z" />
    </g>
  </svg>
);
